import { collection, getDocs, query, where } from 'firebase/firestore'
import type { IAnalysisResult } from '@team-milva/lab-models/resources'
import { db } from '@/firebase/init'
import { reportError } from '@/globals/typescript/utils/reportError'

/**
 * The active analysis results of one order, read straight from Firestore.
 *
 * A direct read with no server-side trace, so a failure is reported (error-reporting.md) and the
 * caller gets an empty list — whatever it builds from results degrades rather than blocking.
 */
export async function fetchOrderAnalysisResults({
  labAccountID,
  orderID,
  operation,
}: {
  labAccountID: string
  orderID: string
  /** kebab-case Sentry `operation` tag — says which surface the read was for. */
  operation: string
}): Promise<IAnalysisResult[]> {
  if (!labAccountID || !orderID) return []
  try {
    const snapshot = await getDocs(
      query(
        collection(db, 'Apps', '-lab-customer-', 'AnalysisResults'),
        where('labAccountID', '==', labAccountID),
        where('orderID', '==', orderID),
        where('activeState', '==', 'active')
      )
    )
    return snapshot.docs.map((docSnap) => docSnap.data() as IAnalysisResult)
  } catch (error) {
    reportError(error, { operation, extra: { orderID } })
    return []
  }
}
